
    import process from 'process';
    import { Buffer } from 'buffer';
    window.process = process;
    window.Buffer = Buffer;
    const bucketurl = window.frontendENV?.WATERMARKED_BUCKET || '';
    document.getElementById('favicon').setAttribute('href', `${bucketurl}/watermarked/favicon.ico`);
    document.getElementById('apple-touch-icon').setAttribute('href', `${bucketurl}/watermarked/logo192.png`);
    document.documentElement.style.setProperty("--watermarked-logo-url", `url(${bucketurl}/watermarked/logo.svg)`);
    document.documentElement.style.setProperty("--watermarked-logo-small-url", `url(${bucketurl}/watermarked/logo_small.svg)`);
  